import { Grid, Icon } from '@mui/material';
import MDBox from 'common/components/MDBox';
import MDButton from 'common/components/MDButton';
import MDTable from 'common/components/MDTable';
import AddEmployeeModel from 'component/AddEmployeeModel';
import EmployeeLeaveModel from 'component/EmployeeLeaveModel';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { deleteEmployee } from 'services/employee/employee';
import { getEmployeeList } from 'services/employee/employee';
import Swal from 'sweetalert2';

const Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 2000,
    onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});

const columns = [
    { field: "name", headerName: "Full Name", accessor: "name", s_key: 's_name' },
    { field: "address", headerName: "Address", accessor: "address", s_key: 's_address' },
    { field: "number", headerName: "Number", accessor: "number", s_key: 's_number' },
    { field: "email", headerName: "Email", accessor: "email", s_key: 's_email' },
    { field: "nic", headerName: "NIC", accessor: "nic", s_key: 's_nic' },
    { field: "action", headerName: "Action", accessor: "action" },
];

export default function Employees() {

    const dispatch = useDispatch();
    const [popUp, setPop] = useState(false);
    const [updateModel, setUpdateModel] = useState(false);
    const [leaveModel, setLeaveModel] = useState(false);
    const [updateData, setUpdateData] = useState({})
    const [tableData, setTableData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [deleteLoader, setDeleteLoader] = useState(false);

    const employeeList = useSelector(state => state.employeeSlice.employee);
    const deleteEmployeeSlice = useSelector(state => state.deleteEmployeeSlice.employee);

    useEffect(() => {
        dispatch(getEmployeeList({ page: currentPage }))
    }, [currentPage])

    useEffect(() => {
        if (employeeList.isSuccess) {
            const data = employeeList.data?.data;

            const array = []
            data.forEach((val) => {
                array.push(
                    {
                        name: val.full_name,
                        address: val.address,
                        number: val.phone,
                        email: val.email,
                        nic: val.nic,
                        action:
                            (
                                <div className="my-class1">
                                    <MDButton
                                        variant="gradient"
                                        color="success"
                                        onClick={() => { setUpdateModel(true); setUpdateData(val) }}
                                    >
                                        <Icon fontSize="medium">edit</Icon>
                                    </MDButton>
                                    <MDButton
                                        variant="gradient"
                                        color="info"
                                        onClick={() => {setLeaveModel(val.emp_id); setUpdateData(val)}}
                                    >
                                        <Icon fontSize="medium">event</Icon>
                                    </MDButton>
                                    <MDButton
                                        variant="gradient"
                                        color="error"
                                        onClick={() => handleDelete(val.emp_id)}
                                    >
                                        <Icon fontSize="medium">delete</Icon>
                                    </MDButton>
                                </div>
                            ),
                    }
                )
            })
            setTableData(array);
        }
    }, [employeeList.data])

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to delete this intake?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                setDeleteLoader(true)
                dispatch(deleteEmployee(id));
            }
        });
    }

    useEffect(() => {
        if (deleteLoader) {
            setDeleteLoader(false)
            if (deleteEmployeeSlice.isSuccess) {
                dispatch(getEmployeeList({ page: currentPage }))
                Toast.fire({
                    icon: 'success',
                    title: 'Employee Deleted Successfully!'
                });
            } else if (deleteEmployeeSlice.isError) {
                Toast.fire({
                    icon: 'error',
                    title: 'Failed to Delete Employee'
                });
            }
        }
    }, [deleteEmployeeSlice.data]);

    return (
        <MDBox pt={6} pb={3}>
            <div className="content">
                <Grid container spacing={0}>
                    <Grid item sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'end', width: '100%' }}>
                        <MDButton
                            variant="gradient"
                            color="info"
                            onClick={() => {
                                setPop(true);
                            }}
                        >
                            <Icon fontSize="large" sx={{ marginRight: 1, marginBottom: 0.2 }}>
                                control_point
                            </Icon>
                            Add New Employee
                        </MDButton>
                    </Grid>
                </Grid>
                <Grid pt={6}>
                    <MDTable
                        tableData={tableData}
                        tableColumns={columns}
                        searchKey={['id', 'name']}
                        page={currentPage - 1}
                        count={employeeList.data?.meta?.pagination?.total}
                        changePage={(val) => setCurrentPage(val + 1)}
                    />
                </Grid>
            </div>
            {popUp &&
                <AddEmployeeModel
                    setShowModal={setPop}
                    showModal={popUp}
                    currentPage={currentPage}
                />
            }

            {updateModel &&
                <AddEmployeeModel
                    setShowModal={setUpdateModel}
                    showModal={updateModel}
                    currentPage={currentPage}
                    update={true}
                    updateData={updateData}
                />
            }

            {leaveModel &&
                <EmployeeLeaveModel
                    setShowModal={setLeaveModel}
                    showModal={leaveModel}
                    empId={updateData?.emp_id}
                />
            }
        </MDBox>
    )
}
